import { Component, OnInit,Input } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { Router } from '@angular/router';
// import { BaseService } from '../../../../services/base.service';
import { UtilService } from '../../../../services/util.service';
import { LoaderService } from '../../../../services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
// import { CacheService } from '../../../../services/cache.service';


@Component({
    selector: 'goals-tracker',
    templateUrl: './goals-tracker.component.html',
    styleUrls: ['./goals-tracker.component.scss'],
    standalone: false
})
export class GoalsTrackerComponent implements OnInit {

  @Input() data: any;
  config: any = {};
  showSkeletonLoader = true;
  height: string;
  constructor(
    private baseService: BaseService,
    public dashBoardService:DashboardService,
    public utilService:UtilService,
    private loader: LoaderService,
    public router: Router, 
    // public cacheService:CacheService
  ) { }

  ngOnInit(): void {
    this.build();
    if (this.utilService.isMobile()) {
      this.height = '90px'
     } else {
      this.height = '180px'
  
     }

  }

  handleLinkClick() {
    this.router.navigate([this.config.data.link]);
  }
  build(){
    // this.loader.showSpinner();
    // if(this.cacheService.checkWidget( 'goal-tracker', this.data.slider_id)) {

    this.baseService.getById(this.data.slider_id, 'widget_config', 'account-management').subscribe(res => {
     this.config.data = res;
    //  this.cacheService.setWidgetStorage('goat-tracker', res);
      if(res && res.document_id){
        this.config.data.imgUrl = this.utilService.getImageUrl(res.document_id);  
      }
      // this.loader.hideSpinner();
      this.showSkeletonLoader = false;
     });
    }
  //   else {
  //     this.cacheService.getWidget().subscribe(value => {
  //      const List = value.filter(ele => ele['goal-tracker']);
  //      const configData = List.filter(ele => ele['goal-tracker'].id === this.data.slider_id)
  //      this.config.data = configData && configData.length > 0 ? configData[0]['goal-tracker'] : '';
  //       this.showSkeletonLoader = false;
  
  //     })
  //   }
  // }

}
